/* eslint-disable react-hooks/exhaustive-deps */
import React, { ReactNode, useEffect, useState } from "react";

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  TextField,
  LinearProgress,
  Typography,
  Snackbar,
  Alert,
  Modal,
  Button,
  IconButton,
  InputAdornment,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import "./style.css";
import { Tooltip } from "@mui/material";
import { AuthenticationApi } from "../../../../API/Authentication/LoginApi";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import AppHeader from "../../../../common/Pages/AppHeader/AppHeader";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import DownloadForOfflineOutlinedIcon from "@mui/icons-material/DownloadForOfflineOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  maxHeight: "90vh",
  overflowY: "auto",
  minWidth: "500px",
};
interface ApproveData {
  supportTicketId: string;
  name: string;
  gender: string | undefined;
  dob: string | undefined;
  documentNumber: string;
  dlClassOfVehicle: string[];
  docType: string; // <-- Add this!
  address: string | undefined;
}

const FleetDailyReport = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState<any>();
  const [kycDetailListData, setKycDetailListData] = useState<any[]>([]);
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success"
  );
  const [rateLimitExceeded, setRateLimitExceeded] = useState(false);
  const [currRateLimit, setCurrRateLimit] = useState<number | null>(null);
  const [maxRateLimit, setMaxRateLimit] = useState<number | null>(null);
  const [trialLimit, setTrialLimit] = useState(""); // 👈 stores input value
  const [expandedDocTitle, setExpandedDocTitle] = useState<string | null>(null);
  const [selectedStatus, setSelectStatus] = useState<string | null>(null);
  const [documentData, setDocumentData] = useState<any>(null);
  const [openRemarks, setOpenRemarks] = useState(false); // for remarks popup
  const [selectedKycId, setSelectedKycId] = useState<number | null>(null); // to store id
  const [query, setQuery] = useState(""); // to store remarks
  const [selectedRow, setSelectedRow] = useState<any>(null); // ✅ Add this new state
  const [searchValInput, setSearchValInput] = useState("");
  const [open, setOpen] = useState(false);
  const userid = selectedRow?.id;
  const [selectedDocumentType, setSelectedDocumentType] = useState<string>(""); // For DL only
  const [selectedDocData, setSelectedDocData] = useState<any>(null);
  const [documentNumber, setDocumentNumber] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [dlClasses, setDlClasses] = useState("");
  const [statusType, setStatusType] = useState("");

  useEffect(() => {
    if (selectedDocData && selectedRow) {
      const docTitle = selectedDocData.title?.toUpperCase();

      setDocumentNumber(selectedDocData.value || "");
      setName(selectedRow.name || "");
      setDob(selectedRow.dob || "");
      setGender(selectedRow.gender || "");

      // Set accordion title and type
      setExpandedDocTitle(docTitle);
      setSelectedDocumentType(docTitle);

      if (docTitle === "ADDRESS_PROOF") {
        setAddress(selectedDocData.value || selectedRow.address || "");
      } else {
        setAddress("");
      }

      if (docTitle === "DL") {
        setDlClasses(
          Array.isArray(selectedDocData.dlClassOfVehicle)
            ? selectedDocData.dlClassOfVehicle
            : selectedDocData.dlClassOfVehicle
            ? [selectedDocData.dlClassOfVehicle]
            : []
        );
      } else {
        setDlClasses("");
      }
    }
  }, [selectedDocData, selectedRow]);

  const handleOpenDocumentModal = async (
    userId: number,
    item: any,
    id: number
  ) => {
    setSelectedDocData(null); // collapses the box
    setSelectedKycId(null);
    setSelectedDocumentType("");
    setExpandedDocTitle(null); // reset expansion on modal reopen

    try {
      const response = await AuthenticationApi.api.getKycDocumentByUserId(
        userId,
        id
      );

      if (response.code === 2000) {
        setDocumentData(response.data);
        setOpen(true);
        setSelectedRow(item);
        setStatusType(item.status);

        const { rateLimitingEntity } = response.data;
        const current = rateLimitingEntity?.currRateLimit ?? null;
        const max = rateLimitingEntity?.maxRateLimit ?? null;

        setCurrRateLimit(current);
        setMaxRateLimit(max);

        setRateLimitExceeded(
          current !== null && max !== null && current >= max
        );

        // ✅ Find first eligible document for accordion
        const firstEligibleDoc = response.data.kycStatusList?.find(
          (doc: any) =>
            doc.status !== 3 &&
            doc.showButton &&
            item?.ticketTypeDto?.key !== "BANK"
        );

        if (firstEligibleDoc) {
          const docTitle = firstEligibleDoc.title?.toUpperCase();
          setExpandedDocTitle(docTitle);
          setSelectedDocData(firstEligibleDoc);
          setSelectedDocumentType(docTitle);

          // Pre-fill fields
          setDocumentNumber(firstEligibleDoc.value || "");
          setName(item?.name || "");
          setDob(item?.dob || "");
          setGender(item?.gender || "");
          setAddress(
            docTitle === "ADDRESS_PROOF"
              ? firstEligibleDoc.value || item?.address || ""
              : ""
          );
          setDlClasses(
            docTitle === "DL"
              ? Array.isArray(firstEligibleDoc.dlClassOfVehicle)
                ? firstEligibleDoc.dlClassOfVehicle
                : firstEligibleDoc.dlClassOfVehicle
                ? [firstEligibleDoc.dlClassOfVehicle]
                : []
              : ""
          );
        }
      } else {
        setSnackbarMessage("Failed to load documents");
        setSnackbarSeverity("error");
        setShowErrorSnackbar(true);
      }
    } catch (error) {
      console.error("Document fetch error:", error);
      setSnackbarMessage("API Error: Something went wrong");
      setSnackbarSeverity("error");
      setShowErrorSnackbar(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleClearSearch = () => {
    setSearchValInput("");
  };
  const handleCloseRemarks = () => {
    setOpenRemarks(false);
    setQuery(""); // clear remarks after closing
  };

  const pageRange = 5;

  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#000",
    font: "Rubik",
  };
  // Dummy data for tables

  const pageCount = Math.ceil(totalCount / rowsPerPage);
  const handlePageChange = (newPage: number) => {
    const newPageNumber = Math.max(1, Math.min(newPage + 1, pageCount));
    setPage(newPageNumber - 1);
  };

  const fetchKycTickets = () => {
    AuthenticationApi.api
      ?.KycTicketList(selectedStatus, page, rowsPerPage, searchValInput)
      .then((response) => {
        if (response.data.length > 0) {
          setKycDetailListData(response.data);
          setTotalCount(response.count);
        } else {
          setKycDetailListData([]);
          setTotalCount(1);
        }
      })
      .catch((error) => {
        console.error("API call error: ", error);
      });
  };
  useEffect(() => {
    setPage(0);
  }, [selectedStatus, searchValInput]);
  useEffect(() => {
    fetchKycTickets();
  }, [page, rowsPerPage, selectedStatus, searchValInput]);

  const renderPageNumbers = () => {
    const pagesToShow = Math.min(pageCount, pageRange);
    const startPage = Math.max(
      0,
      Math.min(page - Math.floor(pageRange / 2), pageCount - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index + 1;
      return (
        <span
          key={index}
          onClick={() => handlePageChange(pageNumber - 1)}
          className={page === pageNumber - 1 ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}
        >
          {pageNumber}
        </span>
      );
    });
  };
  const handleApprove = async (data: ApproveData) => {
    console.log("data.supportTicketId", userid);
    try {
      // Handle BANKSTATEMENT separately
      if (data.docType === "BANK_STATEMENT") {
        if (!userid) {
          setSnackbarMessage("Missing support ticket ID");
          setSnackbarSeverity("error");
          setShowErrorSnackbar(true);
          return;
        }

        const response = await AuthenticationApi.api.approveBankStatement(
          Number(userid)
        );

        if (response?.message === "Success" && response?.code === 2000) {
          setSnackbarMessage("Bank statement approved successfully");
          setSnackbarSeverity("success");
          setShowErrorSnackbar(true);
          fetchKycTickets();
          setOpen(false);
        } else {
          setSnackbarMessage(response?.message || "Approval failed");
          setSnackbarSeverity("error");
          setShowErrorSnackbar(true);
        }
        return;
      }

      // Handle other document types
      const dlClassList = Array.isArray(data.dlClassOfVehicle)
        ? data.dlClassOfVehicle
        : data.dlClassOfVehicle
        ? [data.dlClassOfVehicle]
        : [];

      const response = await AuthenticationApi.api.approvedKycRequest(
        userid,
        data.docType === "ADDRESS_PROOF" ? undefined : data.name,
        data.docType === "ADDRESS_PROOF" ? undefined : data.gender,
        data.docType === "ADDRESS_PROOF" ? undefined : data.dob,
        data.docType === "ADDRESS_PROOF" ? undefined : data.documentNumber,
        data.docType === "ADDRESS_PROOF" ? undefined : dlClassList,
        data.docType === "ADDRESS_PROOF" ? data.address : undefined
      );

      if (response?.message === "Success" && response?.code === 2000) {
        setSnackbarMessage("Approved Successfully");
        setSnackbarSeverity("success");
        setShowErrorSnackbar(true);
        fetchKycTickets();
        setOpen(false);
      } else {
        setSnackbarMessage(response?.message || "Approval failed");
        setSnackbarSeverity("error");
        setShowErrorSnackbar(true);
      }
    } catch (error: any) {
      console.error("Approval error:", error);
      const errorMessage =
        error?.response?.data?.message || error?.message || "Error Approving";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setShowErrorSnackbar(true);
    }
  };

  const handleReject = async () => {
    if (!selectedRow) return;
    try {
      const response = await AuthenticationApi.api?.rejectKycRequest(
        userid,
        query,
        trialLimit
      );

      if (response?.message === "Success" && response?.code === 2000) {
        setSnackbarMessage("Client request rejected successfully!");
        setSnackbarSeverity("success");
        setShowErrorSnackbar(true);
        setOpen(false);
        setOpenRemarks(false);
        setQuery(""); // Clear input
        fetchKycTickets();
      } else if (response?.code === 2001) {
        setSnackbarMessage(response?.message);
        setSnackbarSeverity("error");
        setShowErrorSnackbar(true);
      } else {
        setSnackbarMessage(response?.message || "Rejection failed.");
        setSnackbarSeverity("error");
        setShowErrorSnackbar(true);
      }
    } catch (error: any) {
      // Try to extract a structured error response
      const responseData = error?.response?.data;
      if (responseData?.code === 2001) {
        setSnackbarMessage(responseData.message);
        setSnackbarSeverity("error");
        setShowErrorSnackbar(true);
      } else {
        console.error("Error during rejection:", error);
        setSnackbarMessage("An error occurred during rejection.");
        setSnackbarSeverity("error");
        setShowErrorSnackbar(true);
      }
    }
  };
  let isFormValid = false;
  const aadhaarRegex = /^\d{12}$/;
  const panRegex = /^[A-Z]{5}\d{4}[A-Z]{1}$/;

  if (selectedDocumentType === "AADHAAR") {
    isFormValid =
      aadhaarRegex.test(documentNumber) &&
      name.trim() !== "" &&
      dob.trim() !== "" &&
      gender.trim() !== "";
  } else if (selectedDocumentType === "DL") {
    isFormValid =
      documentNumber.trim() !== "" &&
      name.trim() !== "" &&
      dob.trim() !== "" &&
      dlClasses.length > 0; // ✅ check array length
  } else if (selectedDocumentType === "PAN") {
    isFormValid =
      panRegex.test(documentNumber) && name.trim() !== "" && dob.trim() !== "";
  } else if (selectedDocumentType === "ADDRESS_PROOF") {
    isFormValid = address.trim() !== "";
  }

  return (
    <div>
      <AppHeader />
      <div className="px-10">
        <div className="py-6">
          <Typography variant="h4">KYC Ticket Dashboard</Typography>
        </div>
        <Box sx={{ bgcolor: "#3b3b3b", width: "100%" }}></Box>

        <div className="w-full flex bg-white min-h-80 box-shadow p-3 rounded-xl">
          <div className="w-full">
            <Grid
              container
              spacing={5}
              className="w-full flex justify-between items-center"
            >
              <Grid item md={3}>
                <div className="flex ml-4">
                  <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
                    Kyc Ticket details
                  </h2>
                </div>
              </Grid>
              <Grid item md={9}>
                <div className="flex mr-4 ">
                  <div className="flex w-full justify-end">
                    <div className="mr-3">
                      <TextField
                        placeholder="Search  By Mobile Number"
                        id="outlined-basic"
                        type="number"
                        variant="outlined"
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          const value = event.target.value;
                          // Allow only digits and max 10 characters
                          if (/^\d{0,10}$/.test(value)) {
                            setSearchValInput(value);
                          }
                        }}
                        value={searchValInput}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment
                              position="end"
                              onClick={handleClearSearch}
                            >
                              <ClearIcon style={{ cursor: "pointer" }} />
                            </InputAdornment>
                          ),
                          style: { height: "40px", borderRadius: "25px" },
                        }}
                        inputProps={{
                          maxLength: 10,
                          inputMode: "numeric", // for better mobile keyboard
                          pattern: "[0-9]*",
                        }}
                        sx={{
                          "& input[type=number]": {
                            MozAppearance: "textfield", // Firefox
                          },
                          "& input[type=number]::-webkit-outer-spin-button": {
                            WebkitAppearance: "none",
                            margin: 0,
                          },
                          "& input[type=number]::-webkit-inner-spin-button": {
                            WebkitAppearance: "none",
                            margin: 0,
                          },
                        }}
                        // onKeyDown={handleKeyPress}
                      />
                    </div>
                    <div>
                      <label>Status </label>
                      <select
                        onChange={(date) => {
                          setSelectStatus(date.target.value);
                        }}
                        style={{
                          border: "2px solid",
                          padding: "5px 10px",
                          borderRadius: "5px",
                        }}
                      >
                        <option value=""> All</option>
                        <option value="PENDING">Pending</option>
                        <option value="APPROVED">Approved</option>
                        <option value="REJECTED">Rejected</option>
                      </select>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <hr className="my-4" />

            <TableContainer style={{ width: "100%", overflowX: "auto" }}>
              {!kycDetailListData ? ( // Check if API response is still undefined (loading)
                <LinearProgress />
              ) : typeof kycDetailListData === "string" ? ( // If API returns "No Data Found" as a string
                <Typography style={{ textAlign: "center", padding: "10px" }}>
                  No data available
                </Typography>
              ) : kycDetailListData.length === 0 ? ( // If the array is empty
                <Typography style={{ textAlign: "center", padding: "10px" }}>
                  No data available
                </Typography>
              ) : (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 80 }}
                      >
                        User Id
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 120 }}
                      >
                        Name
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 110 }}
                      >
                        Mobile No
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 110 }}
                      >
                        Ticket Type
                      </TableCell>

                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 120 }}
                      >
                        Date of Birth
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 90 }}
                      >
                        Gender
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 80 }}
                      >
                        City
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 180 }}
                      >
                        Created Time
                      </TableCell>
                       <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 100 }}
                      >
                        Authority
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 150 }}
                      >
                        Address
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 100 }}
                      >
                        Status
                      </TableCell>
                     
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 200 }}
                      >
                        Ticket Completion Time
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 120 }}
                      >
                        Verified By
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 100 }}
                      >
                        Remarks
                      </TableCell>
                       <TableCell
                        style={{
                          ...tableHeaderCellStyle,
                          textAlign: "center",
                          position: "sticky",
                          right: 0,
                          background: "#fff", // or use theme.palette.background.paper
                          zIndex: 1,
                        }}
                        sx={{ minWidth: 100 }}
                      >
                        Documents
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {kycDetailListData.map((item: any, index: any) => (
                      <TableRow key={index}>
                        <TableCell
                          style={{
                            ...tableBodyCellStyle,
                            textAlign: "center",
                          }}
                        >
                          {item.userId}
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableBodyCellStyle,
                            textAlign: "center",
                          }}
                        >
                          {item.name}
                        </TableCell>

                        <TableCell
                          style={{
                            ...tableBodyCellStyle,
                            textAlign: "center",
                          }}
                        >
                          {item.mobileNum}
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableBodyCellStyle,
                            textAlign: "center",
                          }}
                        >
                          {item.ticketTypeDto.value}
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableBodyCellStyle,
                            textAlign: "center",
                          }}
                        >
                          {item.dob}
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableBodyCellStyle,
                            textAlign: "center",
                          }}
                        >
                          {item.gender}
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableBodyCellStyle,
                            textAlign: "center",
                          }}
                        >
                          {item.city}
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableBodyCellStyle,
                            textAlign: "center",
                          }}
                        >
                          {item.createdTime}
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableBodyCellStyle,
                            textAlign: "center",
                          }}
                        >
                          {item.authority}
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableBodyCellStyle,
                            textAlign: "center",
                          }}
                        >
                          <Tooltip title={item.address} arrow>
                            <span>
                              {item.address?.slice(0, 10)}
                              {item.address?.length > 10 ? "..." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableBodyCellStyle,
                            textAlign: "center",
                          }}
                        >
                          <p
                            style={{
                              color:
                                item.status === "PENDING"
                                  ? "#f5be08"
                                  : item.status === "APPROVED"
                                  ? "green"
                                  : item.status === "REJECTED"
                                  ? "red"
                                  : "inherit",
                              fontWeight: "bold",
                            }}
                          >
                            {item.status}
                          </p>
                        </TableCell>
                        
                        <TableCell
                          style={{
                            ...tableBodyCellStyle,
                            textAlign: "center",
                          }}
                        >
                          {item.ticketCompletionTime}
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableBodyCellStyle,
                            textAlign: "center",
                          }}
                        >
                          {item.verifiedBy}
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableBodyCellStyle,
                            textAlign: "center",
                          }}
                        >
                          {item.remarks}
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableBodyCellStyle,
                            textAlign: "center",
                            position: "sticky",
                            right: 0,
                            background: "#fff", // match the table background
                            zIndex: 1,
                          }}
                        >
                          <Stack direction="row" spacing={0}>
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              sx={{ margin: "auto" }}
                            >
                              <img
                                src="/assets/document.svg"
                                alt="document"
                                onClick={() =>
                                  handleOpenDocumentModal(
                                    item.userId,
                                    item,
                                    item.id
                                  )
                                }
                                style={{ cursor: "pointer" }}
                              />
                            </Box>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </TableContainer>

            <div className="pl-2 pt-4 pb-2 pr-16">
              <div
                className="pagination"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <button
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page === 0}
                    style={{
                      fontFamily: "Rubik",
                      fontSize: "20px",
                      marginRight: "6px",
                    }}
                  >
                    {"<"}
                  </button>
                  {renderPageNumbers()}
                  <button
                    onClick={() => handlePageChange(page + 1)}
                    disabled={page >= pageCount - 1}
                    style={{
                      fontFamily: "Rubik",
                      fontSize: "20px",
                      marginLeft: "6px",
                    }}
                  >
                    {">"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <Snackbar
            open={showErrorSnackbar}
            autoHideDuration={6000}
            onClose={() => setShowErrorSnackbar(false)}
          >
            <Alert
              onClose={() => setShowErrorSnackbar(false)}
              severity={snackbarSeverity}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </div>
        <Box sx={{ bgcolor: "background.paper", width: "100%" }}></Box>

        <Modal open={open} onClose={handleClose}>
          <div>
            <Box sx={style}>
              <Grid className="flex justify-end">
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Grid>
              {documentData ? (
                <>
                  <Typography variant="h6" gutterBottom>
                    Selfie
                  </Typography>
                  <Box
                    sx={{
                      width: 220,
                      height: 150,
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      overflow: "hidden",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      bgcolor: "#f5f5f5",
                    }}
                  >
                    <Zoom>
                      <img
                        src={`https://preprod.bcykal.com/mobycy/api/media/file/${documentData.profilePicId}`}
                        alt="Selfie"
                        height="100%"
                        width="100%"
                      />
                    </Zoom>
                  </Box>
                  {/* {selectedRow?.ticketTypeDto?.key === "BANK" && (
                    <Button
                      variant="contained"
                      color="success"
                      sx={{ marginTop: "10px" }}
                      onClick={() => {
                        setOpen(false); // close current modal
                        setQuery(""); // clear any previous remarks
                        setOpenRemarks(true); // open remarks modal
                      }}
                    >
                      OK
                    </Button>
                  )} */}

                  {documentData.kycStatusList?.map((doc: any, idx: number) => (
                    <Box
                      key={idx}
                      mt={4}
                      sx={{ borderTop: "2px solid #000", paddingTop: "15px" }}
                    >
                      <Typography variant="h5" fontWeight="bold">
                        {doc.title.toUpperCase()}
                      </Typography>

                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        width="100%"
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 1,
                            borderBottom: "1px solid #e0e0e0",
                            paddingBottom: "8px",
                            width: "60%",
                          }}
                        >
                          {doc.title === "bankStatement" ? (
                            <Box>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                              >
                                Bank Name
                              </Typography>
                              <Typography variant="subtitle1" fontWeight="bold">
                                {doc.bank}
                              </Typography>

                              <Typography
                                variant="caption"
                                color="textSecondary"
                              >
                                Account Name
                              </Typography>
                              <Typography variant="subtitle1" fontWeight="bold">
                                {doc.accountName}
                              </Typography>

                              <Typography
                                variant="caption"
                                color="textSecondary"
                              >
                                Account Number
                              </Typography>
                              <Typography variant="subtitle1" fontWeight="bold">
                                {doc.accountNumber}
                              </Typography>

                              <Typography
                                variant="caption"
                                color="textSecondary"
                              >
                                IFSC Code
                              </Typography>
                              <Typography variant="subtitle1" fontWeight="bold">
                                {doc.ifscCode}
                              </Typography>
                            </Box>
                          ) : (
                            <Box>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                              >
                                {doc.title.toLowerCase() === "address"
                                  ? doc.title.charAt(0).toUpperCase() +
                                    doc.title.slice(1)
                                  : `${doc.title.toUpperCase()} No.`}
                              </Typography>
                              {doc.value && (
                                <Typography
                                  variant="subtitle1"
                                  fontWeight="bold"
                                >
                                  {doc.value}
                                </Typography>
                              )}
                            </Box>
                          )}
                        </Box>

                        {doc.status === 3 && (
                          <Box display="flex" alignItems="center">
                            <CheckCircleIcon
                              sx={{ color: "#00C853", fontSize: 20 }}
                            />
                            <Typography
                              variant="subtitle2"
                              color="#00C853"
                              fontWeight="bold"
                            >
                              Approved
                            </Typography>
                          </Box>
                        )}

                        {doc.status === 2 && (
                          <Box display="flex" alignItems="center">
                            <CloseCircleIcon
                              sx={{ color: "red", fontSize: 20, mr: "3px" }}
                            />
                            <Typography
                              variant="subtitle2"
                              color="red"
                              fontWeight="bold"
                            >
                              Rejected
                            </Typography>
                          </Box>
                        )}
                        {doc.status === 4 && (
                          <Box display="flex" alignItems="center">
                            <Typography
                              variant="subtitle2"
                              color="Blue"
                              fontWeight="bold"
                            >
                              Skiped
                            </Typography>
                          </Box>
                        )}

                        {(doc.status === 0 ||
                          doc.status === 1 ||
                          doc.status === 5) && (
                          <Box display="flex" alignItems="center">
                            <CloseCircleIcon
                              sx={{
                                color: "#f5be08",
                                fontSize: 20,
                                mr: "3px",
                              }}
                            />
                            <Typography
                              variant="subtitle2"
                              color="#f5be08"
                              fontWeight="bold"
                            >
                              Pending
                            </Typography>
                          </Box>
                        )}
                      </Box>

                      {doc.addressProofType && (
                        <Typography>
                          Proof Type: <b>{doc.addressProofType}</b>
                        </Typography>
                      )}

                      <Box
                        mt={1}
                        display="flex"
                        flexWrap="wrap"
                        gap={2}
                        position="relative"
                      >
                        {doc.imageIds?.map((id: number | null, i: number) =>
                          id ? (
                            <Box key={i} position="relative">
                              <Box
                                display="flex"
                                alignItems="end"
                                position="absolute"
                                top="18px"
                                right="8px"
                                zIndex={2}
                              >
                                <a
                                  href={`https://preprod.bcykal.com/mobycy/api/media/file/${id}`}
                                  download
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "inherit",
                                    textDecoration: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <DownloadForOfflineOutlinedIcon
                                    sx={{
                                      cursor: "pointer",
                                      background: "#fff",
                                      borderRadius: "50%",
                                      padding: "4px",
                                    }}
                                  />
                                </a>
                              </Box>

                              <Box mt={2} display="flex">
                                <Box
                                  sx={{
                                    width: 220,
                                    height: 150,
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    bgcolor: "#fafafa",
                                  }}
                                >
                                  {doc.title.toLowerCase() ===
                                  "bank_statement" ? (
                                    <Box padding="10px">
                                      <img
                                        src={`https://preprod.bcykal.com/mobycy/api/media/file/${id}`}
                                        alt={`${doc.title} ${i + 1}`}
                                        style={{
                                          maxWidth: "100%",
                                          maxHeight: "100%",
                                          objectFit: "contain",
                                        }}
                                        onError={(e) => {
                                          e.currentTarget.style.display =
                                            "none";
                                        }}
                                      />
                                      <Typography
                                        variant="caption"
                                        color="textSecondary"
                                      >
                                        PDF and Excel file not viewable. Click
                                        download icon above.
                                      </Typography>
                                    </Box>
                                  ) : (
                                    <Zoom>
                                      <img
                                        src={`https://preprod.bcykal.com/mobycy/api/media/file/${id}`}
                                        alt={`${doc.title} ${i + 1}`}
                                        style={{
                                          maxWidth: "100%",
                                          maxHeight: "100%",
                                          objectFit: "contain",
                                        }}
                                        onError={(e) => {
                                          e.currentTarget.style.display =
                                            "none";
                                        }}
                                      />
                                    </Zoom>
                                  )}
                                </Box>
                              </Box>
                            </Box>
                          ) : null
                        )}
                      </Box>

                      {selectedRow?.ticketTypeDto?.key !== "BANK" &&
                        doc.status !== 3 &&
                        statusType !== "REJECTED" &&
                        doc.showButton &&
                        selectedDocData?.id === doc.id && (
                          <Accordion
                            expanded={
                              expandedDocTitle === doc.title.toUpperCase()
                            }
                            onChange={() => {
                              const title = doc.title.toUpperCase();
                              const isExpanding = expandedDocTitle !== title;

                              setExpandedDocTitle(isExpanding ? title : null);
                              setSelectedDocData(isExpanding ? doc : null);
                              setSelectedDocumentType(isExpanding ? title : "");

                              // Pre-fill form data only on expand
                              if (isExpanding) {
                                setDocumentNumber(doc.value || "");
                                setName(selectedRow?.name || "");
                                setDob(selectedRow?.dob || "");
                                setGender(selectedRow?.gender || "");
                                setAddress(
                                  title === "ADDRESS_PROOF"
                                    ? doc.value || selectedRow?.address || ""
                                    : ""
                                );
                                setDlClasses(
                                  title === "DL"
                                    ? Array.isArray(doc.dlClassOfVehicle)
                                      ? doc.dlClassOfVehicle
                                      : doc.dlClassOfVehicle
                                      ? [doc.dlClassOfVehicle]
                                      : []
                                    : ""
                                );
                              } else {
                                // Clear form if collapsing
                                setDocumentNumber("");
                                setName("");
                                setDob("");
                                setGender("");
                                setAddress("");
                                setDlClasses("");
                              }
                            }}
                            className="mt-4"
                          >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <Typography variant="h6">
                                Approve {doc.title.toUpperCase()}
                              </Typography>
                            </AccordionSummary>
                            {expandedDocTitle === doc.title.toUpperCase() && (
                              <AccordionDetails>
                                {selectedDocumentType === "BANK_STATEMENT" ? (
                                  <Box
                                    mt={2}
                                    display="flex"
                                    justifyContent="flex-end"
                                    gap={2}
                                  >
                                    <Button
                                      variant="contained"
                                      color="error"
                                      onClick={() => {
                                        setOpen(false);
                                        setSelectedKycId(doc.id);
                                        setOpenRemarks(true);
                                      }}
                                    >
                                      Reject BANKSTATEMENT
                                    </Button>

                                    <Button
                                      variant="contained"
                                      color="success"
                                      onClick={() =>
                                        handleApprove({
                                          supportTicketId: String(doc.id), // 👈 Ensure it's a string
                                          name: "", // not required
                                          gender: undefined,
                                          dob: "",
                                          documentNumber: "",
                                          dlClassOfVehicle: [],
                                          docType: "BANK_STATEMENT", // pass the type
                                          address: undefined,
                                        })
                                      }
                                    >
                                      Approve BANKSTATEMENT
                                    </Button>
                                  </Box>
                                ) : (
                                  <>
                                    <Typography variant="subtitle1">
                                      Please Fill all the Fields To Approve
                                      <span style={{ color: "red" }}>*</span>
                                    </Typography>
                                    {selectedDocumentType ===
                                    "ADDRESS_PROOF" ? (
                                      <TextField
                                        label="Address"
                                        type="text"
                                        fullWidth
                                        value={address}
                                        onChange={(e) =>
                                          setAddress(e.target.value)
                                        }
                                        margin="normal"
                                        InputLabelProps={{ shrink: true }}
                                      />
                                    ) : (
                                      <>
                                        <TextField
                                          label={`Document Number ${doc.title.toUpperCase()}`}
                                          fullWidth
                                          value={documentNumber}
                                          onChange={(e) => {
                                            let input =
                                              e.target.value.toUpperCase();

                                            if (
                                              selectedDocumentType === "AADHAAR"
                                            ) {
                                              // Aadhaar: 12 digits only
                                              input = input.replace(/\D/g, ""); // Only digits
                                              if (input.length > 12)
                                                input = input.slice(0, 12);
                                            } else if (
                                              selectedDocumentType === "PAN"
                                            ) {
                                              // PAN: 5 letters + 4 digits + 1 letter
                                              input = input.replace(
                                                /[^A-Z0-9]/g,
                                                ""
                                              ); // Only uppercase alphanumeric
                                              if (input.length > 10)
                                                input = input.slice(0, 10);
                                            } else {
                                              // Other: Alphanumeric only, up to 20 chars
                                              input = input.replace(
                                                /[^A-Z0-9]/g,
                                                ""
                                              );
                                              if (input.length > 30)
                                                input = input.slice(0, 30);
                                            }

                                            setDocumentNumber(input);
                                          }}
                                          margin="normal"
                                        />

                                        <TextField
                                          label="Name"
                                          fullWidth
                                          value={name}
                                          onChange={(e) =>
                                            setName(e.target.value)
                                          }
                                          margin="normal"
                                        />
                                        <TextField
                                          label="DOB"
                                          type="date"
                                          fullWidth
                                          value={dob}
                                          onChange={(e) =>
                                            setDob(e.target.value)
                                          }
                                          margin="normal"
                                          InputLabelProps={{ shrink: true }}
                                          inputProps={{
                                            max: new Date()
                                              .toISOString()
                                              .split("T")[0], // Disallow future dates
                                            min: "1900-01-01", // Optional: disallow overly old dates
                                          }}
                                        />

                                        {selectedDocumentType === "AADHAAR" && (
                                          <TextField
                                            select
                                            fullWidth
                                            // label="Gender"
                                            value={gender}
                                            onChange={(e) =>
                                              setGender(e.target.value)
                                            }
                                            margin="normal"
                                            SelectProps={{ native: true }}
                                          >
                                            <option value="" disabled>
                                              Select Gender
                                            </option>
                                            <option value="Male">Male</option>
                                            <option value="Female">
                                              Female
                                            </option>
                                          </TextField>
                                        )}
                                        {selectedDocumentType === "DL" && (
                                          <FormControl
                                            fullWidth
                                            margin="normal"
                                          >
                                            <InputLabel id="dl-class-label">
                                              DL Class of Vehicle
                                            </InputLabel>
                                            <Select
                                              labelId="dl-class-label"
                                              multiple
                                              value={dlClasses}
                                              onChange={(e: any) =>
                                                setDlClasses(e.target.value)
                                              }
                                              label="DL Class of Vehicle"
                                            >
                                              <MenuItem value="LL">LL</MenuItem>
                                              <MenuItem value="MCWG">
                                                MCWG
                                              </MenuItem>
                                              <MenuItem value="LMV">
                                                LMV
                                              </MenuItem>
                                              <MenuItem value="MGV">
                                                MGV
                                              </MenuItem>
                                              <MenuItem value="HMV">
                                                HMV
                                              </MenuItem>
                                              <MenuItem value="HTV">
                                                HTV
                                              </MenuItem>
                                              <MenuItem value="LMV-TR">
                                                LMV-TR
                                              </MenuItem>
                                              <MenuItem value="LMV-CAB">
                                                LMV-CAB
                                              </MenuItem>
                                              <MenuItem value="3W-GV">
                                                3W-GV
                                              </MenuItem>
                                              <MenuItem value="MCWOG">
                                                MCWOG
                                              </MenuItem>
                                              <MenuItem value="E-RICKSHAW">
                                                E-RICKSHAW
                                              </MenuItem>
                                              <MenuItem value="TRANS">
                                                TRANS
                                              </MenuItem>
                                              <MenuItem value="ADPVEH">
                                                ADPVEH
                                              </MenuItem>
                                              <MenuItem value="3W-NT">
                                                3W-NT
                                              </MenuItem>
                                            </Select>
                                          </FormControl>
                                        )}
                                      </>
                                    )}

                                    <Box
                                      mt={2}
                                      display="flex"
                                      justifyContent="flex-end"
                                      gap={2}
                                    >
                                      <Button
                                        variant="contained"
                                        color="error"
                                        onClick={() => {
                                          setOpen(false);
                                          setSelectedKycId(doc.id);
                                          setOpenRemarks(true);
                                        }}
                                      >
                                        Reject {doc.title.toUpperCase()}
                                      </Button>

                                      <Button
                                        variant="contained"
                                        disabled={!isFormValid}
                                        color="success"
                                        onClick={() => {
                                          handleApprove({
                                            supportTicketId: doc.id,
                                            name,
                                            gender:
                                              selectedDocumentType === "AADHAAR"
                                                ? gender
                                                : undefined,
                                            dob,
                                            documentNumber,
                                            dlClassOfVehicle:
                                              selectedDocumentType === "DL"
                                                ? Array.isArray(dlClasses)
                                                  ? dlClasses
                                                  : dlClasses
                                                  ? [dlClasses]
                                                  : []
                                                : [],
                                            docType: selectedDocumentType,
                                            address:
                                              selectedDocumentType ===
                                              "ADDRESS_PROOF"
                                                ? address
                                                : undefined,
                                          });
                                        }}
                                      >
                                        Approve {doc.title.toUpperCase()}
                                      </Button>
                                    </Box>
                                  </>
                                )}
                              </AccordionDetails>
                            )}
                          </Accordion>
                        )}
                      {doc.title === "bank" &&
                        currRateLimit !== null &&
                        maxRateLimit !== null &&
                        doc.status !== 2 &&
                        doc.showButton && (
                          <Box
                            mt={2}
                            display="flex"
                            justifyContent="flex-end"
                            gap={2}
                          >
                            {currRateLimit < maxRateLimit && (
                              <Button
                                variant="contained"
                                color="error"
                                onClick={handleReject}
                              >
                                Reject {doc.title.toUpperCase()}
                              </Button>
                            )}

                            {currRateLimit >= maxRateLimit && (
                              <Button
                                variant="contained"
                                color="error"
                                onClick={() => {
                                  setOpen(false);
                                  setSelectedKycId(doc.id);
                                  setOpenRemarks(true);
                                }}
                              >
                                Reject {doc.title.toUpperCase()}
                              </Button>
                            )}
                            {doc.status === 2 && (
                              <Box display="flex" alignItems="center">
                                <CloseCircleIcon
                                  sx={{ color: "red", fontSize: 20, mr: "3px" }}
                                />
                                <Typography
                                  variant="subtitle2"
                                  color="red"
                                  fontWeight="bold"
                                >
                                  Rejected
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        )}
                    </Box>
                  ))}
                </>
              ) : (
                <Typography>Loading...</Typography>
              )}
            </Box>

            {/* Approve Modal - only rendered when selectedDocData is present */}
          </div>
        </Modal>

        <Modal open={openRemarks} onClose={handleCloseRemarks}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              width: "auto",
            }}
          >
            {selectedRow?.ticketTypeDto?.key !== "BANK" && (
              <>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  <Typography variant="h6">
                    Remarks To Reject {expandedDocTitle}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <IconButton onClick={handleCloseRemarks}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
                <TextField
                  multiline
                  rows={4}
                  fullWidth
                  value={query}
                  onChange={(e) => {
                    const text = e.target.value;
                    if (text.length <= 100) {
                      setQuery(text);
                    }
                  }}
                  inputProps={{ maxLength: 100 }}
                  helperText={`${query.length}/100 Max Limit`}
                  FormHelperTextProps={{ style: { textAlign: "right" } }}
                />
                <Box mt={2} display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="success"
                    onClick={handleReject}
                    disabled={!query.trim()}
                  >
                    Submit
                  </Button>
                </Box>
              </>
            )}

            {rateLimitExceeded && (
              <Box
                display="flex"
                alignItems="center"
                gap={1}
                bgcolor="#f1fdf5"
                border="1px solid #b2f5ea"
                borderRadius={2}
                p={2}
                mb={2}
                mt={2}
              >
                <CheckCircleIcon sx={{ color: "red" }} />
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    USER LIMIT EXCEED
                  </Typography>
                </Box>
              </Box>
            )}
            {currRateLimit !== null &&
              maxRateLimit !== null &&
              currRateLimit >= maxRateLimit && (
                <>
                  <Typography variant="subtitle2" mt={2}>
                    To Reset Limit, Enter No. less than {maxRateLimit}
                  </Typography>

                  <TextField
                    fullWidth
                    label="Enter Trial Limit"
                    type="number"
                    value={trialLimit}
                    onChange={(e) => setTrialLimit(e.target.value)}
                    inputProps={{ min: 0, max: maxRateLimit }}
                    error={!!trialLimit && Number(trialLimit) > maxRateLimit}
                    helperText={
                      !!trialLimit && Number(trialLimit) > maxRateLimit
                        ? `Limit exceeded. Please enter a value less than ${maxRateLimit}.`
                        : ""
                    }
                    margin="normal"
                  />
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button
                      variant="contained"
                      color="success"
                      onClick={handleReject}
                      disabled={
                        trialLimit === null ||
                        maxRateLimit === null ||
                        Number(trialLimit) >= maxRateLimit
                      }
                    >
                      Submit
                    </Button>
                  </Box>
                </>
              )}
          </Box>
        </Modal>
      </div>
    </div>
  );
};

export default FleetDailyReport;
